import { FormlyTemplateOptions } from '@ngx-formly/core';

import { ThemePalette } from '@angular/material/core';

export interface ISnDetailedCheckboxTemplateOptions extends FormlyTemplateOptions {
  color?: ThemePalette;
  mainLabel?: string;
  secondaryText?: string;
  icon?: string;
  hideLabel?: boolean;
}
